import Vue from 'vue'
import Router from 'vue-router'
import MenuView from '@/views/common/MenuView'
import PageView from '@/views/common/PageView'
import LoginView from '@/views/login/Common'
import EmptyPageView from '@/views/common/EmptyPageView'
import HomePageView from '@/views/HomePage'
import db from 'utils/localstorage'
import request from 'utils/request'

// 全局Router异常处理
const originalPush = Router.prototype.push

Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => { if (typeof err !== 'undefined')console.log(err) })
}
Vue.use(Router)

let constRouter = [
  {
    path: '/login',
    name: '登录页',
    component: LoginView
  },
  {
    path: '/autoLogin',
    name: '商户账号自动登录',
    component: () => import('@/views/login/AutoLogin')
  },
  {
    path: '/index',
    name: '首页',
    redirect: '/home'
  },
  {
    path: '/mobilePay',
    name: '支付',
    component:() => import('@/views/mobilePay/index.vue')
  },
  {
    path: '/PayError',
    name: '支付失败',
    component:() => import('@/views/mobilePay/error.vue')
  },
  {
    path: '/vendorPay',
    name: '收钱吧支付',
    component:() => import('@/views/vendorPay/index.vue')
  },
  {
    path: '/vendorPayError',
    name: '收钱吧支付失败',
    component:() => import('@/views/vendorPay/error.vue')
  },
  {
    path: '/syPay',
    name: '云管家支付',
    component:() => import('@/views/syPay/index.vue')
  },
  {
    path: '/remotePrint/:recordCode?',
    name: '远程打印上传',
    component:() => import('@/views/remotePrint/index.vue')
  },
  {
    path: '/photoDownload/:orderCode',
    name: '电子照片下载',
    component:() => import('@/views/photoDownload/index.vue')
  }
]

let router = new Router({
  routes: constRouter
})

const whiteList = ['/login','/autoLogin','/mobilePay','/PayError','/vendorPay','/vendorPayError','/remotePrint','/photoDownload']

// 检查路径是否在白名单中（支持动态路由匹配）
function isInWhiteList (path) {
  if (whiteList.indexOf(path) !== -1) return true
  // 支持 /remotePrint/:recordCode 动态路由
  if (path.startsWith('/remotePrint/')) return true
  // 支持 /photoDownload/:orderCode 动态路由（客户扫码免登录访问）
  if (path.startsWith('/photoDownload/')) return true
  return false
}

let asyncRouter

// 导航守卫，渲染动态路由
router.beforeEach((to, from, next) => {
  if (isInWhiteList(to.path)) {
    next()
    return
  }

  let user = db.get('USER')
  let userRouter = get('USER_ROUTER')
  let token = db.get('USER_TOKEN')
  if (token.length && user) {
    if (!asyncRouter) {
      if (!userRouter) {
        request.get(`menu/${user.username}`).then((res) => {
          asyncRouter = res.data
          console.log('get: ', asyncRouter)
          save('USER_ROUTER', asyncRouter)
          go(to, next)
        }).catch(err => { console.error(err) })
      } else {
        asyncRouter = userRouter
        console.log('go: ', userRouter)
        go(to, next)
      }
    } else {
      next()
    }
  } else {
    next('/login')
  }
})

function go (to, next) {
  asyncRouter = filterAsyncRouter(asyncRouter)
  console.log('in go: ', asyncRouter)
  router.addRoutes(asyncRouter)
  next({...to, replace: true})
}

function save (name, data) {
  localStorage.setItem(name, JSON.stringify(data))
}

function get (name) {
  return JSON.parse(localStorage.getItem(name))
}

function filterAsyncRouter (routes) {
  return routes.filter((route) => {
    let component = route.component
    if (component) {
      switch (route.component) {
        case 'MenuView':
          route.component = MenuView
          break
        case 'PageView':
          route.component = PageView
          break
        case 'EmptyPageView':
          route.component = EmptyPageView
          break
        case 'HomePageView':
          route.component = HomePageView
          break
        default:
          route.component = view(component)
      }
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children)
      }
      return true
    }
  })
}

function view (path) {
  return function (resolve) {
    import(`@/views/${path}.vue`).then(mod => {
      resolve(mod)
    })
  }
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js